import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/no-shadow,  @typescript-eslint/no-empty-interface */
import { createAction } from '../../interfaces';
import httpProviderService from '../../services/provider';
import * as definitions from '../../definitions/provider';
import { authActionCreators } from './auth';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var providerActionCreators = {
  getProviderServiceRequest: function getProviderServiceRequest(providerService) {
    return createAction(definitions.GET_PROVIDER_SERVICE_REQUEST, providerService);
  },
  getProviderServiceSuccess: function getProviderServiceSuccess(providerService) {
    return createAction(definitions.GET_PROVIDER_SERVICE_SUCCESS, providerService);
  },
  getProviderServiceFail: function getProviderServiceFail(error) {
    return createAction(definitions.GET_PROVIDER_SERVICE_FAIL, error);
  },
  createServiceProspectRequest: function createServiceProspectRequest(serviceProspect) {
    return createAction(definitions.CREATE_SERVICE_PROSPECT_REQUEST, serviceProspect);
  },
  createServiceProspectSuccess: function createServiceProspectSuccess(serviceProspect) {
    return createAction(definitions.CREATE_SERVICE_PROSPECT_SUCCESS, serviceProspect);
  },
  createServiceProspectFail: function createServiceProspectFail(error) {
    return createAction(definitions.CREATE_SERVICE_PROSPECT_FAIL, error);
  },
  confirmServiceProspectRequest: function confirmServiceProspectRequest(serviceProspect) {
    return createAction(definitions.CONFIRM_SERVICE_PROSPECT_REQUEST, serviceProspect);
  },
  confirmServiceProspectSuccess: function confirmServiceProspectSuccess(response) {
    return createAction(definitions.CONFIRM_SERVICE_PROSPECT_SUCCESS, response);
  },
  confirmServiceProspectFail: function confirmServiceProspectFail(error) {
    return createAction(definitions.CONFIRM_SERVICE_PROSPECT_FAIL, error);
  },
  getProviderRequest: function getProviderRequest(provider) {
    return createAction(definitions.GET_PROVIDER_REQUEST, provider);
  },
  getProviderSuccess: function getProviderSuccess(provider) {
    return createAction(definitions.GET_PROVIDER_SUCCESS, provider);
  },
  loggedInProviderSuccess: function loggedInProviderSuccess(provider) {
    return createAction(definitions.LOGGED_IN_PROVIDER_SUCCESS, provider);
  },
  getProviderFail: function getProviderFail(error) {
    return createAction(definitions.GET_PROVIDER_FAIL, error);
  },
  getPostsRequest: function getPostsRequest(serviceId) {
    return createAction(definitions.GET_POSTS_REQUEST, serviceId);
  },
  getPostsSuccess: function getPostsSuccess(posts) {
    return createAction(definitions.GET_POSTS_SUCCESS, posts);
  },
  getPostsFail: function getPostsFail(error) {
    return createAction(definitions.GET_POSTS_FAIL, error);
  },
  unsubscribeServiceProspectRequest: function unsubscribeServiceProspectRequest(serviceProspect) {
    return createAction(definitions.UNSUBSCRIBE_SERVICE_PROSPECT_REQUEST, serviceProspect);
  },
  unsubscribeServiceProspectSuccess: function unsubscribeServiceProspectSuccess(serviceProspect) {
    return createAction(definitions.UNSUBSCRIBE_SERVICE_PROSPECT_REQUEST_SUCCESS, serviceProspect);
  },
  unsubscribeServiceProspectFail: function unsubscribeServiceProspectFail(serviceProspect) {
    return createAction(definitions.UNSUBSCRIBE_SERVICE_PROSPECT_REQUEST_FAIL, serviceProspect);
  },
  unsubscribeServiceSubscriberRequest: function unsubscribeServiceSubscriberRequest(subscriber) {
    return createAction(definitions.UNSUBSCRIBE_SERVICE_SUBSCRIBER_REQUEST, subscriber);
  },
  unsubscribeServiceSubscriberSuccess: function unsubscribeServiceSubscriberSuccess(subscriber) {
    return createAction(definitions.UNSUBSCRIBE_SERVICE_SUBSCRIBER_REQUEST_SUCCESS, subscriber);
  },
  unsubscribeServiceSubscriberFail: function unsubscribeServiceSubscriberFail(subscriber) {
    return createAction(definitions.UNSUBSCRIBE_SERVICE_SUBSCRIBER_REQUEST_FAIL, subscriber);
  },
  unsubscribeProviderServiceRequest: function unsubscribeProviderServiceRequest(providerService) {
    return createAction(definitions.UNSUBSCRIBE_PROVIDER_SERVICE_REQUEST, providerService);
  },
  unsubscribeProviderServiceSuccess: function unsubscribeProviderServiceSuccess(providerService) {
    return createAction(definitions.UNSUBSCRIBE_PROVIDER_SERVICE_REQUEST_SUCCESS, providerService);
  },
  unsubscribeProviderServiceFail: function unsubscribeProviderServiceFail(error) {
    return createAction(definitions.UNSUBSCRIBE_PROVIDER_SERVICE_REQUEST_FAIL, error);
  },
  getSurveyRequest: function getSurveyRequest() {
    return createAction(definitions.GET_SURVEY_REQUEST);
  },
  getSurveySuccess: function getSurveySuccess(survey) {
    return createAction(definitions.GET_SURVEY_SUCCESS, survey);
  },
  getSurveyFail: function getSurveyFail(error) {
    return createAction(definitions.GET_SURVEY_FAIL, error);
  },
  getPlanSurveyAnswersSuccess: function getPlanSurveyAnswersSuccess(planSurveyAnswers) {
    return createAction(definitions.GET_PLAN_SURVEY_ANSWERS_SUCCESS, planSurveyAnswers);
  },
  submitSurveyRequest: function submitSurveyRequest(surveyAnswers) {
    return createAction(definitions.SUBMIT_SURVEY_REQUEST, surveyAnswers);
  },
  submitSurveySuccess: function submitSurveySuccess() {
    return createAction(definitions.SUBMIT_SURVEY_SUCCESS);
  },
  submitSurveyFail: function submitSurveyFail(error) {
    return createAction(definitions.SUBMIT_SURVEY_FAIL, error);
  },
  createSurveyRequest: function createSurveyRequest(payload) {
    return createAction(definitions.CREATE_SURVEY_REQUEST, payload);
  },
  createSurveySuccess: function createSurveySuccess(survey) {
    return createAction(definitions.CREATE_SURVEY_SUCCESS, survey);
  },
  createSurveyFail: function createSurveyFail(error) {
    return createAction(definitions.CREATE_SURVEY_FAIL, error);
  },
  updateSurveyRequest: function updateSurveyRequest(payload) {
    return createAction(definitions.UPDATE_SURVEY_REQUEST, payload);
  },
  updateSurveySuccess: function updateSurveySuccess(survey) {
    return createAction(definitions.UPDATE_SURVEY_SUCCESS, survey);
  },
  updateSurveyFail: function updateSurveyFail(error) {
    return createAction(definitions.UPDATE_SURVEY_FAIL, error);
  },
  getServiceProspectsRequest: function getServiceProspectsRequest(serviceId) {
    return createAction(definitions.GET_SERVICE_PROSPECTS_REQUEST, serviceId);
  },
  getServiceProspectsSuccess: function getServiceProspectsSuccess(serviceProspects) {
    return createAction(definitions.GET_SERVICE_PROSPECTS_SUCCESS, serviceProspects);
  },
  getServiceProspectsFail: function getServiceProspectsFail(error) {
    return createAction(definitions.GET_SERVICE_PROSPECTS_FAIL, error);
  },
  getPostRequest: function getPostRequest() {
    return createAction(definitions.GET_POST_REQUEST);
  },
  getPostSuccess: function getPostSuccess(post) {
    return createAction(definitions.GET_POST_SUCCESS, post);
  },
  getPostFail: function getPostFail(error) {
    return createAction(definitions.GET_POST_FAIL, error);
  },
  createPostRequest: function createPostRequest() {
    return createAction(definitions.CREATE_POST_REQUEST);
  },
  createPostSuccess: function createPostSuccess(post) {
    return createAction(definitions.CREATE_POST_SUCCESS, post);
  },
  createPostFail: function createPostFail(error) {
    return createAction(definitions.CREATE_POST_FAIL, error);
  },
  updatePostRequest: function updatePostRequest() {
    return createAction(definitions.UPDATE_POST_REQUEST);
  },
  updatePostSuccess: function updatePostSuccess(post) {
    return createAction(definitions.UPDATE_POST_SUCCESS, post);
  },
  updatePostPublishStatusSuccess: function updatePostPublishStatusSuccess(post) {
    return createAction(definitions.UPDATE_POST_PUBLISH_STATUS_SUCCESS, post);
  },
  updatePostFail: function updatePostFail(error) {
    return createAction(definitions.UPDATE_POST_FAIL, error);
  },
  deletePostRequest: function deletePostRequest() {
    return createAction(definitions.DELETE_POST_REQUEST);
  },
  deletePostSuccess: function deletePostSuccess(postId) {
    return createAction(definitions.DELETE_POST_SUCCESS, {
      id: postId
    });
  },
  deletePostFail: function deletePostFail(error) {
    return createAction(definitions.DELETE_POST_FAIL, error);
  },
  emailPostRequest: function emailPostRequest() {
    return createAction(definitions.EMAIL_POST_REQUEST);
  },
  emailPostSuccess: function emailPostSuccess() {
    return createAction(definitions.EMAIL_POST_SUCCESS);
  },
  emailPostFail: function emailPostFail(error) {
    return createAction(definitions.EMAIL_POST_FAIL, error);
  },
  testEmailPostRequest: function testEmailPostRequest() {
    return createAction(definitions.TEST_EMAIL_POST_REQUEST);
  },
  testEmailPostSuccess: function testEmailPostSuccess() {
    return createAction(definitions.TEST_EMAIL_POST_SUCCESS);
  },
  testEmailPostFail: function testEmailPostFail(error) {
    return createAction(definitions.TEST_EMAIL_POST_FAIL, error);
  },
  emailPostReset: function emailPostReset() {
    return createAction(definitions.EMAIL_POST_RESET);
  },
  clearProviderErrors: function clearProviderErrors() {
    return createAction(definitions.CLEAR_PROVIDER_ERRORS);
  },
  setProviderInfo: function setProviderInfo(info) {
    return createAction(definitions.SET_PROVIDER_INFO, info);
  },
  clearProviderInfo: function clearProviderInfo() {
    return createAction(definitions.CLEAR_PROVIDER_INFO);
  },
  clearProviderData: function clearProviderData() {
    return createAction(definitions.CLEAR_PROVIDER_DATA);
  },
  createEmailCampaignRequest: function createEmailCampaignRequest() {
    return createAction(definitions.CREATE_EMAIL_CAMPAIGN_REQUEST);
  },
  createEmailCampaignSuccess: function createEmailCampaignSuccess(emailCampaign) {
    return createAction(definitions.CREATE_EMAIL_CAMPAIGN_SUCCESS, emailCampaign);
  },
  createEmailCampaignFail: function createEmailCampaignFail(error) {
    return createAction(definitions.CREATE_EMAIL_CAMPAIGN_FAIL, error);
  },
  getEmailCampaignRequest: function getEmailCampaignRequest() {
    return createAction(definitions.GET_EMAIL_CAMPAIGN_REQUEST);
  },
  getEmailCampaignSuccess: function getEmailCampaignSuccess(emailCampaign) {
    return createAction(definitions.GET_EMAIL_CAMPAIGN_SUCCESS, emailCampaign);
  },
  getEmailCampaignFail: function getEmailCampaignFail(error) {
    return createAction(definitions.GET_EMAIL_CAMPAIGN_FAIL, error);
  },
  getEmailCampaignListRequest: function getEmailCampaignListRequest() {
    return createAction(definitions.GET_EMAIL_CAMPAIGN_LIST_REQUEST);
  },
  getEmailCampaignListSuccess: function getEmailCampaignListSuccess(emailCampaign) {
    return createAction(definitions.GET_EMAIL_CAMPAIGN_LIST_SUCCESS, emailCampaign);
  },
  getEmailCampaignListFail: function getEmailCampaignListFail(error) {
    return createAction(definitions.GET_EMAIL_CAMPAIGN_LIST_FAIL, error);
  },
  getSurveyResultRequest: function getSurveyResultRequest() {
    return createAction(definitions.GET_SURVEY_RESULTS_REQUEST);
  },
  getSurveyResultSuccess: function getSurveyResultSuccess(surveyResults) {
    return createAction(definitions.GET_SURVEY_RESULTS_SUCCESS, surveyResults);
  },
  getSurveyResultFail: function getSurveyResultFail(error) {
    return createAction(definitions.GET_SURVEY_RESULTS_FAIL, error);
  },
  getAllSurveyResultsRequest: function getAllSurveyResultsRequest() {
    return createAction(definitions.GET_ALL_SURVEY_RESULTS_REQUEST);
  },
  getAllSurveyResultsSuccess: function getAllSurveyResultsSuccess(surveyResults) {
    return createAction(definitions.GET_ALL_SURVEY_RESULTS_SUCCESS, surveyResults);
  },
  getAllSurveyResultsFail: function getAllSurveyResultsFail(error) {
    return createAction(definitions.GET_ALL_SURVEY_RESULTS_FAIL, error);
  },
  getScheduleRequest: function getScheduleRequest() {
    return createAction(definitions.GET_SCHEDULE_REQUEST);
  },
  getScheduleSuccess: function getScheduleSuccess(schedule) {
    return createAction(definitions.GET_SCHEDULE_SUCCESS, schedule);
  },
  getScheduleFail: function getScheduleFail(error) {
    return createAction(definitions.GET_SCHEDULE_FAIL, error);
  },
  getServicePlansRequest: function getServicePlansRequest() {
    return createAction(definitions.GET_SERVICE_PLANS_REQUEST);
  },
  getServicePlansSuccess: function getServicePlansSuccess(servicePlans) {
    return createAction(definitions.GET_SERVICE_PLANS_SUCCESS, servicePlans);
  },
  getServicePlansFail: function getServicePlansFail(error) {
    return createAction(definitions.GET_SERVICE_PLANS_FAIL, error);
  },
  getPlanRequest: function getPlanRequest() {
    return createAction(definitions.GET_PLAN_REQUEST);
  },
  getPlanSuccess: function getPlanSuccess(plan) {
    return createAction(definitions.GET_PLAN_SUCCESS, plan);
  },
  getPlanFail: function getPlanFail(error) {
    return createAction(definitions.GET_PLAN_FAIL, error);
  },
  createPlanRequest: function createPlanRequest() {
    return createAction(definitions.CREATE_PLAN_REQUEST);
  },
  createPlanSuccess: function createPlanSuccess(plan) {
    return createAction(definitions.CREATE_PLAN_SUCCESS, plan);
  },
  createPlanFail: function createPlanFail(error) {
    return createAction(definitions.CREATE_PLAN_FAIL, error);
  },
  updatePlanRequest: function updatePlanRequest() {
    return createAction(definitions.UPDATE_PLAN_REQUEST);
  },
  updatePlanSuccess: function updatePlanSuccess(plan) {
    return createAction(definitions.UPDATE_PLAN_SUCCESS, plan);
  },
  updatePlanFail: function updatePlanFail(error) {
    return createAction(definitions.UPDATE_PLAN_FAIL, error);
  },
  activatePlanRequest: function activatePlanRequest() {
    return createAction(definitions.ACTIVATE_PLAN_REQUEST);
  },
  activatePlanSuccess: function activatePlanSuccess(plan) {
    return createAction(definitions.ACTIVATE_PLAN_SUCCESS, plan);
  },
  activatePlanFail: function activatePlanFail(error) {
    return createAction(definitions.ACTIVATE_PLAN_FAIL, error);
  },
  deactivatePlanRequest: function deactivatePlanRequest() {
    return createAction(definitions.DEACTIVATE_PLAN_REQUEST);
  },
  deactivatePlanSuccess: function deactivatePlanSuccess(plan) {
    return createAction(definitions.DEACTIVATE_PLAN_SUCCESS, plan);
  },
  deactivatePlanFail: function deactivatePlanFail(error) {
    return createAction(definitions.DEACTIVATE_PLAN_FAIL, error);
  },
  deletePlanRequest: function deletePlanRequest() {
    return createAction(definitions.DELETE_PLAN_REQUEST);
  },
  deletePlanSuccess: function deletePlanSuccess(planId) {
    return createAction(definitions.DELETE_PLAN_SUCCESS, {
      id: planId
    });
  },
  deletePlanFail: function deletePlanFail(error) {
    return createAction(definitions.DELETE_PLAN_FAIL, error);
  },
  deletePlanFeatureRequest: function deletePlanFeatureRequest() {
    return createAction(definitions.DELETE_PLAN_FEATURE_REQUEST);
  },
  deletePlanFeatureSuccess: function deletePlanFeatureSuccess(featureId) {
    return createAction(definitions.DELETE_PLAN_FEATURE_SUCCESS, {
      id: featureId
    });
  },
  deletePlanFeatureFail: function deletePlanFeatureFail(error) {
    return createAction(definitions.DELETE_PLAN_FEATURE_FAIL, error);
  },
  getServiceSubscriptionsRequest: function getServiceSubscriptionsRequest() {
    return createAction(definitions.GET_SERVICE_SUBSCRIPTIONS_REQUEST);
  },
  getServiceSubscriptionsSuccess: function getServiceSubscriptionsSuccess(subscribers) {
    return createAction(definitions.GET_SERVICE_SUBSCRIPTIONS_SUCCESS, subscribers);
  },
  getServiceSubscriptionsFail: function getServiceSubscriptionsFail(error) {
    return createAction(definitions.GET_SERVICE_SUBSCRIPTIONS_FAIL, error);
  },
  getServiceCustomersPromoTrueRequest: function getServiceCustomersPromoTrueRequest() {
    return createAction(definitions.GET_PROMO_TRUE_SERVICE_CUSTOMERS_REQUEST);
  },
  getServiceCustomersPromoTrueSuccess: function getServiceCustomersPromoTrueSuccess(subscribers) {
    return createAction(definitions.GET_PROMO_TRUE_SERVICE_CUSTOMERS_SUCCESS, subscribers);
  },
  getServiceCustomersPromoTrueFail: function getServiceCustomersPromoTrueFail(error) {
    return createAction(definitions.GET_PROMO_TRUE_SERVICE_CUSTOMERS_FAIL, error);
  },
  getServiceCustomersRequest: function getServiceCustomersRequest() {
    return createAction(definitions.GET_SERVICE_CUSTOMERS_REQUEST);
  },
  getServiceCustomersSuccess: function getServiceCustomersSuccess(serviceCustomers) {
    return createAction(definitions.GET_SERVICE_CUSTOMERS_SUCCESS, serviceCustomers);
  },
  getServiceCustomersFail: function getServiceCustomersFail(error) {
    return createAction(definitions.GET_SERVICE_CUSTOMERS_FAIL, error);
  },
  createVerifiedServiceProspectRequest: function createVerifiedServiceProspectRequest(serviceProspect) {
    return createAction(definitions.CREATE_VERIFIED_SERVICE_PROSPECT_REQUEST, serviceProspect);
  },
  createVerifiedServiceProspectSuccess: function createVerifiedServiceProspectSuccess(serviceProspect) {
    return createAction(definitions.CREATE_VERIFIED_SERVICE_PROSPECT_SUCCESS, serviceProspect);
  },
  createVerifiedServiceProspectFail: function createVerifiedServiceProspectFail(error) {
    return createAction(definitions.CREATE_VERIFIED_SERVICE_PROSPECT_FAIL, error);
  },
  uploadServiceProspectsRequest: function uploadServiceProspectsRequest(serviceProspect) {
    return createAction(definitions.UPLOAD_SERVICE_PROSPECTS_REQUEST, serviceProspect);
  },
  uploadServiceProspectsSuccess: function uploadServiceProspectsSuccess(serviceProspects) {
    return createAction(definitions.UPLOAD_SERVICE_PROSPECTS_SUCCESS, serviceProspects);
  },
  uploadServiceProspectsFail: function uploadServiceProspectsFail(error) {
    return createAction(definitions.UPLOAD_SERVICE_PROSPECTS_FAIL, error);
  },
  updateProviderServiceSuccess: function updateProviderServiceSuccess(providerService, message) {
    return createAction(definitions.UPDATE_PROVIDER_SERVICE_SUCCESS, {
      providerService: providerService,
      message: message
    });
  },
  updateProviderServiceFail: function updateProviderServiceFail(error) {
    return createAction(definitions.UPDATE_PROVIDER_SERVICE_FAIL, error);
  },
  createProviderRequest: function createProviderRequest(provider) {
    return createAction(definitions.CREATE_PROVIDER, provider);
  },
  createProviderSuccess: function createProviderSuccess(provider) {
    return createAction(definitions.CREATE_PROVIDER_SUCCESS, provider);
  },
  createProviderFail: function createProviderFail(error) {
    return createAction(definitions.CREATE_PROVIDER_FAIL, error);
  },
  createProviderServiceRequest: function createProviderServiceRequest(provider) {
    return createAction(definitions.CREATE_PROVIDER_SERVICE, provider);
  },
  createProviderServiceSuccess: function createProviderServiceSuccess(provider) {
    return createAction(definitions.CREATE_PROVIDER_SERVICE_SUCCESS, provider);
  },
  createProviderServiceFail: function createProviderServiceFail(error) {
    return createAction(definitions.CREATE_PROVIDER_SERVICE_FAIL, error);
  },
  updateProviderRequest: function updateProviderRequest(provider) {
    return createAction(definitions.UPDATE_PROVIDER, provider);
  },
  updateProviderSuccess: function updateProviderSuccess(provider) {
    return createAction(definitions.UPDATE_PROVIDER_SUCCESS, provider);
  },
  updateProviderFail: function updateProviderFail(error) {
    return createAction(definitions.UPDATE_PROVIDER_FAIL, error);
  },
  setProviderSelectedServiceId: function setProviderSelectedServiceId(id) {
    return createAction(definitions.SET_PROVIDER_SELECTED_SERVICE_ID, id);
  },
  getServiceTermsRequest: function getServiceTermsRequest() {
    return createAction(definitions.GET_SERVICE_TERMS_REQUEST);
  },
  getServiceTermsSuccess: function getServiceTermsSuccess(serviceTerms) {
    return createAction(definitions.GET_SERVICE_TERMS_SUCCESS, serviceTerms);
  },
  getServiceTermsFail: function getServiceTermsFail(error) {
    return createAction(definitions.GET_SERVICE_TERMS_FAIL, error);
  },
  emailSessionAttendeesRequest: function emailSessionAttendeesRequest() {
    return createAction(definitions.EMAIL_SESSION_ATTENDEES_REQUEST);
  },
  emailSessionAttendeesSuccess: function emailSessionAttendeesSuccess() {
    return createAction(definitions.EMAIL_SESSION_ATTENDEES_SUCCESS);
  },
  emailSessionAttendeesFail: function emailSessionAttendeesFail(error) {
    return createAction(definitions.EMAIL_SESSION_ATTENDEES_FAIL, error);
  },
  getActiveReferralProgramRequest: function getActiveReferralProgramRequest() {
    return createAction(definitions.GET_ACTIVE_REFERRAL_PROGRAM_REQUEST);
  },
  getActiveReferralProgramSuccess: function getActiveReferralProgramSuccess(referralProgram) {
    return createAction(definitions.GET_ACTIVE_REFERRAL_PROGRAM_SUCCESS, referralProgram);
  },
  getActiveReferralProgramFail: function getActiveReferralProgramFail(error) {
    return createAction(definitions.GET_ACTIVE_REFERRAL_PROGRAM_FAIL, error);
  },
  getServicePostMailingListRequest: function getServicePostMailingListRequest() {
    return createAction(definitions.GET_SERVICE_MAILING_LIST_REQUEST);
  },
  getServicePostMailingListSuccess: function getServicePostMailingListSuccess(servicePostMailingList) {
    return createAction(definitions.GET_SERVICE_MAILING_LIST_SUCCESS, servicePostMailingList);
  },
  getServicePostMailingListFail: function getServicePostMailingListFail(error) {
    return createAction(definitions.GET_SERVICE_MAILING_LIST_FAIL, error);
  },
  createServiceTermsRequest: function createServiceTermsRequest() {
    return createAction(definitions.CREATE_SERVICE_TERMS_REQUEST);
  },
  createServiceTermsSuccess: function createServiceTermsSuccess(serviceTerms) {
    return createAction(definitions.CREATE_SERVICE_TERMS_SUCCESS, serviceTerms);
  },
  createServiceTermsFail: function createServiceTermsFail(error) {
    return createAction(definitions.CREATE_SERVICE_TERMS_FAIL, error);
  },
  updateServiceTermsRequest: function updateServiceTermsRequest() {
    return createAction(definitions.UPDATE_SERVICE_TERMS_REQUEST);
  },
  updateServiceTermsSuccess: function updateServiceTermsSuccess(serviceTerms) {
    return createAction(definitions.UPDATE_SERVICE_TERMS_SUCCESS, serviceTerms);
  },
  updateServiceTermsFail: function updateServiceTermsFail(error) {
    return createAction(definitions.UPDATE_SERVICE_TERMS_FAIL, error);
  },
  providerServiceDidChange: function providerServiceDidChange(providerService) {
    return createAction(definitions.PROVIDER_SERVICE_DID_CHANGE, providerService);
  },
  providerDidChange: function providerDidChange(provider) {
    return createAction(definitions.PROVIDER_DID_CHANGE, provider);
  },
  createPlanProspectRequest: function createPlanProspectRequest() {
    return createAction(definitions.CREATE_PLAN_PROSPECT_REQUEST);
  },
  createPlanProspectSuccess: function createPlanProspectSuccess(planProspect) {
    return createAction(definitions.CREATE_PLAN_PROSPECT_SUCCESS, planProspect);
  },
  createPlanProspectFail: function createPlanProspectFail(error) {
    return createAction(definitions.CREATE_PLAN_PROSPECT_FAIL, error);
  },
  getPlanProspectsRequest: function getPlanProspectsRequest() {
    return createAction(definitions.GET_PLAN_PROSPECTS_REQUEST);
  },
  getPlanProspectsSuccess: function getPlanProspectsSuccess(planProspects) {
    return createAction(definitions.GET_PLAN_PROSPECTS_SUCCESS, planProspects);
  },
  getPlanProspectsFail: function getPlanProspectsFail(error) {
    return createAction(definitions.GET_PLAN_PROSPECTS_FAIL, error);
  }
};
export var clearProviderData = function clearProviderData() {
  return function (dispatch) {
    var clearProviderDataAction = providerActionCreators.clearProviderData;
    dispatch(clearProviderDataAction());
  };
};
export var emailSessionAttendees = function emailSessionAttendees(serviceId, sessionId, payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var emailSessionAttendeesRequest, emailSessionAttendeesSuccess, emailSessionAttendeesFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              emailSessionAttendeesRequest = providerActionCreators.emailSessionAttendeesRequest, emailSessionAttendeesSuccess = providerActionCreators.emailSessionAttendeesSuccess, emailSessionAttendeesFail = providerActionCreators.emailSessionAttendeesFail;
              dispatch(emailSessionAttendeesRequest());
              return _context.abrupt("return", httpProviderService.emailSessionAttendees(serviceId, sessionId, payload).then(function () {
                dispatch(emailSessionAttendeesSuccess());
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(emailSessionAttendeesFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getProviderService = function getProviderService(slug) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var getProviderServiceRequest, getProviderServiceSuccess, getProviderServiceFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getProviderServiceRequest = providerActionCreators.getProviderServiceRequest, getProviderServiceSuccess = providerActionCreators.getProviderServiceSuccess, getProviderServiceFail = providerActionCreators.getProviderServiceFail;
              dispatch(getProviderServiceRequest(slug));
              return _context2.abrupt("return", httpProviderService.getProviderServiceBySlug(slug).then(function (service) {
                dispatch(getProviderServiceSuccess(service));
                return service;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getProviderServiceFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var unsubscribeProvider = function unsubscribeProvider(payload) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var unsubscribeProviderServiceRequest, unsubscribeProviderServiceSuccess, unsubscribeProviderServiceFail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              unsubscribeProviderServiceRequest = providerActionCreators.unsubscribeProviderServiceRequest, unsubscribeProviderServiceSuccess = providerActionCreators.unsubscribeProviderServiceSuccess, unsubscribeProviderServiceFail = providerActionCreators.unsubscribeProviderServiceFail;
              dispatch(unsubscribeProviderServiceRequest(payload));
              return _context3.abrupt("return", httpProviderService.providerServiceUnsubscribeFromEmailing(payload).then(function (service) {
                dispatch(unsubscribeProviderServiceSuccess(service));
                return service;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(unsubscribeProviderServiceFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var getProviderServiceById = function getProviderServiceById(serviceId) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var getProviderServiceRequest, getProviderServiceSuccess, getProviderServiceFail;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getProviderServiceRequest = providerActionCreators.getProviderServiceRequest, getProviderServiceSuccess = providerActionCreators.getProviderServiceSuccess, getProviderServiceFail = providerActionCreators.getProviderServiceFail;
              dispatch(getProviderServiceRequest(serviceId));
              return _context4.abrupt("return", httpProviderService.getProviderServiceById(serviceId).then(function (service) {
                dispatch(getProviderServiceSuccess(service));
                return service;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getProviderServiceFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var createServiceProspect = function createServiceProspect(payload) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var createServiceProspectRequest, createServiceProspectSuccess, createServiceProspectFail;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              createServiceProspectRequest = providerActionCreators.createServiceProspectRequest, createServiceProspectSuccess = providerActionCreators.createServiceProspectSuccess, createServiceProspectFail = providerActionCreators.createServiceProspectFail;
              dispatch(createServiceProspectRequest(payload));
              return _context5.abrupt("return", httpProviderService.createServiceProspect(payload).then(function (serviceProspect) {
                dispatch(createServiceProspectSuccess(serviceProspect));
                return serviceProspect;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createServiceProspectFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var getProvider = function getProvider(payload) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var getProviderRequest, getProviderSuccess, getProviderFail;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              getProviderRequest = providerActionCreators.getProviderRequest, getProviderSuccess = providerActionCreators.getProviderSuccess, getProviderFail = providerActionCreators.getProviderFail;
              dispatch(getProviderRequest(payload));
              return _context6.abrupt("return", httpProviderService.getProviderBySlug(payload).then(function (provider) {
                dispatch(getProviderSuccess(provider));
                return provider;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getProviderFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var confirmServiceProspect = function confirmServiceProspect(payload) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var confirmServiceProspectRequest, confirmServiceProspectSuccess, confirmServiceProspectFail;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              confirmServiceProspectRequest = providerActionCreators.confirmServiceProspectRequest, confirmServiceProspectSuccess = providerActionCreators.confirmServiceProspectSuccess, confirmServiceProspectFail = providerActionCreators.confirmServiceProspectFail;
              dispatch(confirmServiceProspectRequest(payload));
              return _context7.abrupt("return", httpProviderService.confirmServiceProspect(payload).then(function (serviceProspect) {
                dispatch(confirmServiceProspectSuccess({
                  serviceProspect: serviceProspect,
                  provider: payload.provider,
                  skipNotification: payload.skipNotification
                }));
                return serviceProspect;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(confirmServiceProspectFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var getSurvey = function getSurvey(payload) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch) {
      var getSurveyRequest, getSurveySuccess, getSurveyFail;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              getSurveyRequest = providerActionCreators.getSurveyRequest, getSurveySuccess = providerActionCreators.getSurveySuccess, getSurveyFail = providerActionCreators.getSurveyFail;
              dispatch(getSurveyRequest());
              return _context8.abrupt("return", httpProviderService.getProviderSurvey(payload).then(function (survey) {
                dispatch(getSurveySuccess(survey));
                return survey;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getSurveyFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var getPlanSurvey = function getPlanSurvey(planId) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch) {
      var getSurveyRequest, getSurveySuccess, getSurveyFail;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              getSurveyRequest = providerActionCreators.getSurveyRequest, getSurveySuccess = providerActionCreators.getSurveySuccess, getSurveyFail = providerActionCreators.getSurveyFail;
              dispatch(getSurveyRequest());
              return _context9.abrupt("return", httpProviderService.getPlanSurvey(planId).then(function (survey) {
                dispatch(getSurveySuccess(survey));
                return survey;
              }, function (error) {
                dispatch(getSurveyFail(error));
              }));

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var getAllAnswersForPlan = function getAllAnswersForPlan(planId) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch) {
      var getPlanSurveyAnswersSuccess;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              getPlanSurveyAnswersSuccess = providerActionCreators.getPlanSurveyAnswersSuccess;
              return _context10.abrupt("return", httpProviderService.getAllAnswersForPlan(planId).then(function (planSurveyAnswers) {
                dispatch(getPlanSurveyAnswersSuccess(planSurveyAnswers));
                return planSurveyAnswers;
              }, function () {
                return void 0;
              }));

            case 2:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
};
export var submitSurveyAnswers = function submitSurveyAnswers(payload) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dispatch) {
      var submitSurveyRequest, submitSurveySuccess, submitSurveyFail;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              submitSurveyRequest = providerActionCreators.submitSurveyRequest, submitSurveySuccess = providerActionCreators.submitSurveySuccess, submitSurveyFail = providerActionCreators.submitSurveyFail;
              dispatch(submitSurveyRequest(payload));
              return _context11.abrupt("return", httpProviderService.submitSurveyAnswers(payload).then(function () {
                dispatch(submitSurveySuccess());
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(submitSurveyFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x11) {
      return _ref11.apply(this, arguments);
    };
  }();
};
export var createSurvey = function createSurvey(payload) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(dispatch) {
      var createSurveyRequest, createSurveySuccess, createSurveyFail;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              createSurveyRequest = providerActionCreators.createSurveyRequest, createSurveySuccess = providerActionCreators.createSurveySuccess, createSurveyFail = providerActionCreators.createSurveyFail;
              dispatch(createSurveyRequest(payload));
              return _context12.abrupt("return", httpProviderService.createSurvey(payload).then(function (survey) {
                dispatch(createSurveySuccess(survey));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createSurveyFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x12) {
      return _ref12.apply(this, arguments);
    };
  }();
};
export var updateSurvey = function updateSurvey(payload) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(dispatch) {
      var updateSurveyRequest, updateSurveySuccess, updateSurveyFail;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              updateSurveyRequest = providerActionCreators.updateSurveyRequest, updateSurveySuccess = providerActionCreators.updateSurveySuccess, updateSurveyFail = providerActionCreators.updateSurveyFail;
              dispatch(updateSurveyRequest(payload));
              return _context13.abrupt("return", httpProviderService.updateSurvey(payload).then(function (survey) {
                dispatch(updateSurveySuccess(survey));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateSurveyFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x13) {
      return _ref13.apply(this, arguments);
    };
  }();
};
export var getPosts = function getPosts(payload) {
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(dispatch) {
      var getPostsRequest, getPostsSuccess, getPostsFail;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              getPostsRequest = providerActionCreators.getPostsRequest, getPostsSuccess = providerActionCreators.getPostsSuccess, getPostsFail = providerActionCreators.getPostsFail;
              dispatch(getPostsRequest(payload));
              return _context14.abrupt("return", httpProviderService.getPosts(payload).then(function (posts) {
                dispatch(getPostsSuccess(posts));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getPostsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function (_x14) {
      return _ref14.apply(this, arguments);
    };
  }();
};
export var unsubscribeServiceProspect = function unsubscribeServiceProspect(payload) {
  return /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(dispatch) {
      var unsubscribeServiceProspectRequest, unsubscribeServiceProspectSuccess, unsubscribeServiceProspectFail;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              unsubscribeServiceProspectRequest = providerActionCreators.unsubscribeServiceProspectRequest, unsubscribeServiceProspectSuccess = providerActionCreators.unsubscribeServiceProspectSuccess, unsubscribeServiceProspectFail = providerActionCreators.unsubscribeServiceProspectFail;
              dispatch(unsubscribeServiceProspectRequest(payload));
              return _context15.abrupt("return", httpProviderService.unsubscribeFromEmailing(payload).then(function (serviceProspect) {
                dispatch(unsubscribeServiceProspectSuccess(serviceProspect));
                return serviceProspect;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(unsubscribeServiceProspectFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x15) {
      return _ref15.apply(this, arguments);
    };
  }();
};
export var unsubscribeServiceSubscriber = function unsubscribeServiceSubscriber(payload) {
  return /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(dispatch) {
      var unsubscribeServiceSubscriberRequest, unsubscribeServiceSubscriberSuccess, unsubscribeServiceSubscriberFail;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              unsubscribeServiceSubscriberRequest = providerActionCreators.unsubscribeServiceSubscriberRequest, unsubscribeServiceSubscriberSuccess = providerActionCreators.unsubscribeServiceSubscriberSuccess, unsubscribeServiceSubscriberFail = providerActionCreators.unsubscribeServiceSubscriberFail;
              dispatch(unsubscribeServiceSubscriberRequest(payload));
              return _context16.abrupt("return", httpProviderService.subscriberUnsubscribeFromEmails(payload).then(function (subscriber) {
                dispatch(unsubscribeServiceSubscriberSuccess(subscriber));
                return subscriber;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(unsubscribeServiceSubscriberFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function (_x16) {
      return _ref16.apply(this, arguments);
    };
  }();
};
export var getPost = function getPost(serviceId, postId) {
  return /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(dispatch) {
      var getPostRequest, getPostSuccess, getPostFail;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              getPostRequest = providerActionCreators.getPostRequest, getPostSuccess = providerActionCreators.getPostSuccess, getPostFail = providerActionCreators.getPostFail;
              dispatch(getPostRequest());
              return _context17.abrupt("return", httpProviderService.getPost(serviceId, postId).then(function (post) {
                dispatch(getPostSuccess(post));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getPostFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function (_x17) {
      return _ref17.apply(this, arguments);
    };
  }();
};
export var getServiceProspects = function getServiceProspects(serviceId, options) {
  return /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(dispatch) {
      var getServiceProspectsRequest, getServiceProspectsSuccess, getServiceProspectsFail;
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              getServiceProspectsRequest = providerActionCreators.getServiceProspectsRequest, getServiceProspectsSuccess = providerActionCreators.getServiceProspectsSuccess, getServiceProspectsFail = providerActionCreators.getServiceProspectsFail;
              dispatch(getServiceProspectsRequest(serviceId));
              return _context18.abrupt("return", httpProviderService.getServiceProspects(serviceId, options).then(function (serviceProspects) {
                dispatch(getServiceProspectsSuccess(serviceProspects));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getServiceProspectsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function (_x18) {
      return _ref18.apply(this, arguments);
    };
  }();
};
export var createPost = function createPost(serviceId, post) {
  return /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(dispatch) {
      var createPostRequest, createPostSuccess, createPostFail;
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              createPostRequest = providerActionCreators.createPostRequest, createPostSuccess = providerActionCreators.createPostSuccess, createPostFail = providerActionCreators.createPostFail;
              dispatch(createPostRequest());
              return _context19.abrupt("return", httpProviderService.createPost(serviceId, post).then(function (post) {
                dispatch(createPostSuccess(post));
                return post;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createPostFail(message));
                handleErrorResponse(error, dispatch);
                return error;
              }));

            case 3:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    return function (_x19) {
      return _ref19.apply(this, arguments);
    };
  }();
};
export var updatePost = function updatePost(serviceId, postId, payload) {
  return /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(dispatch) {
      var updatePostRequest, updatePostSuccess, updatePostPublishStatusSuccess, updatePostFail;
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              updatePostRequest = providerActionCreators.updatePostRequest, updatePostSuccess = providerActionCreators.updatePostSuccess, updatePostPublishStatusSuccess = providerActionCreators.updatePostPublishStatusSuccess, updatePostFail = providerActionCreators.updatePostFail;

              if (!(!payload.title || !payload.body)) {
                _context20.next = 3;
                break;
              }

              return _context20.abrupt("return");

            case 3:
              dispatch(updatePostRequest());
              return _context20.abrupt("return", httpProviderService.updatePost(serviceId, postId, payload).then(function (post) {
                if (typeof payload.published === 'boolean') {
                  dispatch(updatePostPublishStatusSuccess(post));
                } else {
                  dispatch(updatePostSuccess(post));
                }

                return post;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updatePostFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 5:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    return function (_x20) {
      return _ref20.apply(this, arguments);
    };
  }();
};
export var deletePost = function deletePost(serviceId, postId) {
  return /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(dispatch) {
      var deletePostRequest, deletePostSuccess, deletePostFail;
      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              deletePostRequest = providerActionCreators.deletePostRequest, deletePostSuccess = providerActionCreators.deletePostSuccess, deletePostFail = providerActionCreators.deletePostFail;
              dispatch(deletePostRequest());
              return _context21.abrupt("return", httpProviderService.deletePost(serviceId, postId).then(function () {
                dispatch(deletePostSuccess(postId));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(deletePostFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    return function (_x21) {
      return _ref21.apply(this, arguments);
    };
  }();
};
export var emailPost = function emailPost(serviceId, postId, target, planIds) {
  return /*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(dispatch) {
      var emailPostRequest, emailPostSuccess, emailPostFail;
      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              emailPostRequest = providerActionCreators.emailPostRequest, emailPostSuccess = providerActionCreators.emailPostSuccess, emailPostFail = providerActionCreators.emailPostFail;
              dispatch(emailPostRequest());
              return _context22.abrupt("return", httpProviderService.emailPost(serviceId, postId, target, planIds).then(function () {
                dispatch(emailPostSuccess());
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(emailPostFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    return function (_x22) {
      return _ref22.apply(this, arguments);
    };
  }();
};
export var testEmailPost = function testEmailPost(serviceId, postId) {
  return /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(dispatch) {
      var testEmailPostRequest, testEmailPostSuccess, testEmailPostFail;
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              testEmailPostRequest = providerActionCreators.testEmailPostRequest, testEmailPostSuccess = providerActionCreators.testEmailPostSuccess, testEmailPostFail = providerActionCreators.testEmailPostFail;
              dispatch(testEmailPostRequest());
              return _context23.abrupt("return", httpProviderService.postTestEmail(serviceId, postId).then(function () {
                dispatch(testEmailPostSuccess());
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(testEmailPostFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    return function (_x23) {
      return _ref23.apply(this, arguments);
    };
  }();
};
export var resetEmailPostSent = function resetEmailPostSent() {
  return function (dispatch) {
    var emailPostReset = providerActionCreators.emailPostReset;
    dispatch(emailPostReset());
  };
};
export var createEmailCampaign = function createEmailCampaign(serviceId, payload) {
  return /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(dispatch) {
      var createEmailCampaignRequest, createEmailCampaignSuccess, createEmailCampaignFail;
      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              createEmailCampaignRequest = providerActionCreators.createEmailCampaignRequest, createEmailCampaignSuccess = providerActionCreators.createEmailCampaignSuccess, createEmailCampaignFail = providerActionCreators.createEmailCampaignFail;
              dispatch(createEmailCampaignRequest());
              return _context24.abrupt("return", httpProviderService.createEmailCampaign(serviceId, payload).then(function (emailCampaign) {
                dispatch(createEmailCampaignSuccess(emailCampaign));
                return emailCampaign;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createEmailCampaignFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    return function (_x24) {
      return _ref24.apply(this, arguments);
    };
  }();
};
export var getEmailCampaign = function getEmailCampaign(serviceId, emailCampaignId) {
  return /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(dispatch) {
      var getEmailCampaignRequest, getEmailCampaignSuccess, getEmailCampaignFail;
      return _regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              getEmailCampaignRequest = providerActionCreators.getEmailCampaignRequest, getEmailCampaignSuccess = providerActionCreators.getEmailCampaignSuccess, getEmailCampaignFail = providerActionCreators.getEmailCampaignFail;
              dispatch(getEmailCampaignRequest());
              return _context25.abrupt("return", httpProviderService.getEmailCampaign(serviceId, emailCampaignId).then(function (emailCampaign) {
                dispatch(getEmailCampaignSuccess(emailCampaign));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getEmailCampaignFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));

    return function (_x25) {
      return _ref25.apply(this, arguments);
    };
  }();
};
export var getEmailCampaignList = function getEmailCampaignList(serviceId) {
  return /*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(dispatch) {
      var getEmailCampaignListRequest, getEmailCampaignListSuccess, getEmailCampaignListFail;
      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              getEmailCampaignListRequest = providerActionCreators.getEmailCampaignListRequest, getEmailCampaignListSuccess = providerActionCreators.getEmailCampaignListSuccess, getEmailCampaignListFail = providerActionCreators.getEmailCampaignListFail;
              dispatch(getEmailCampaignListRequest());
              return _context26.abrupt("return", httpProviderService.getEmailCampaignList(serviceId).then(function (emailCampaignList) {
                dispatch(getEmailCampaignListSuccess(emailCampaignList));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getEmailCampaignListFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    return function (_x26) {
      return _ref26.apply(this, arguments);
    };
  }();
};
export var clearProviderErrors = function clearProviderErrors() {
  return function (dispatch) {
    var clearProviderErrorsAction = providerActionCreators.clearProviderErrors;
    dispatch(clearProviderErrorsAction());
  };
};
export var setProviderInfo = function setProviderInfo(info) {
  return function (dispatch) {
    var setProviderInfoAction = providerActionCreators.setProviderInfo;
    dispatch(setProviderInfoAction(info));
  };
};
export var clearProviderInfo = function clearProviderInfo() {
  return function (dispatch) {
    var clearProviderInfoAction = providerActionCreators.clearProviderInfo;
    dispatch(clearProviderInfoAction());
  };
};
export var getSurveyResults = function getSurveyResults(surveyId) {
  return /*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(dispatch) {
      var getSurveyResultRequest, getSurveyResultSuccess, getSurveyResultFail;
      return _regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              getSurveyResultRequest = providerActionCreators.getSurveyResultRequest, getSurveyResultSuccess = providerActionCreators.getSurveyResultSuccess, getSurveyResultFail = providerActionCreators.getSurveyResultFail;
              dispatch(getSurveyResultRequest());
              return _context27.abrupt("return", httpProviderService.getSurveyResults(surveyId).then(function (surveyResults) {
                dispatch(getSurveyResultSuccess(surveyResults));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getSurveyResultFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    return function (_x27) {
      return _ref27.apply(this, arguments);
    };
  }();
};
export var getAllSurveyResults = function getAllSurveyResults(providerServiceId) {
  return /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(dispatch) {
      var getAllSurveyResultsRequest, getAllSurveyResultsSuccess, getAllSurveyResultsFail;
      return _regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              getAllSurveyResultsRequest = providerActionCreators.getAllSurveyResultsRequest, getAllSurveyResultsSuccess = providerActionCreators.getAllSurveyResultsSuccess, getAllSurveyResultsFail = providerActionCreators.getAllSurveyResultsFail;
              dispatch(getAllSurveyResultsRequest());
              return _context28.abrupt("return", httpProviderService.getAllSurveyResults(providerServiceId).then(function (surveyResults) {
                dispatch(getAllSurveyResultsSuccess(surveyResults));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getAllSurveyResultsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    return function (_x28) {
      return _ref28.apply(this, arguments);
    };
  }();
};
export var getSchedule = function getSchedule(payload) {
  return /*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(dispatch) {
      var getScheduleRequest, getScheduleSuccess, getScheduleFail;
      return _regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              getScheduleRequest = providerActionCreators.getScheduleRequest, getScheduleSuccess = providerActionCreators.getScheduleSuccess, getScheduleFail = providerActionCreators.getScheduleFail;
              dispatch(getScheduleRequest());
              return _context29.abrupt("return", httpProviderService.getSchedule(payload).then(function (schedule) {
                dispatch(getScheduleSuccess(schedule));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getScheduleFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    return function (_x29) {
      return _ref29.apply(this, arguments);
    };
  }();
};
export var getServicePlans = function getServicePlans(serviceId) {
  return /*#__PURE__*/function () {
    var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(dispatch) {
      var getServicePlansRequest, getServicePlansSuccess, getServicePlansFail;
      return _regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              getServicePlansRequest = providerActionCreators.getServicePlansRequest, getServicePlansSuccess = providerActionCreators.getServicePlansSuccess, getServicePlansFail = providerActionCreators.getServicePlansFail;
              dispatch(getServicePlansRequest());
              return _context30.abrupt("return", httpProviderService.getServicePlans(serviceId).then(function (plans) {
                dispatch(getServicePlansSuccess(plans));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getServicePlansFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    return function (_x30) {
      return _ref30.apply(this, arguments);
    };
  }();
};
export var getPlan = function getPlan(planId) {
  return /*#__PURE__*/function () {
    var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(dispatch) {
      var getPlanRequest, getPlanSuccess, getPlanFail;
      return _regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              getPlanRequest = providerActionCreators.getPlanRequest, getPlanSuccess = providerActionCreators.getPlanSuccess, getPlanFail = providerActionCreators.getPlanFail;
              dispatch(getPlanRequest());
              return _context31.abrupt("return", httpProviderService.getServicePlan(planId).then(function (plan) {
                dispatch(getPlanSuccess(plan));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getPlanFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    return function (_x31) {
      return _ref31.apply(this, arguments);
    };
  }();
};
export var createServicePlan = function createServicePlan(payload) {
  return /*#__PURE__*/function () {
    var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(dispatch) {
      var createPlanRequest, createPlanSuccess, createPlanFail;
      return _regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              createPlanRequest = providerActionCreators.createPlanRequest, createPlanSuccess = providerActionCreators.createPlanSuccess, createPlanFail = providerActionCreators.createPlanFail;
              dispatch(createPlanRequest());
              return _context32.abrupt("return", httpProviderService.createServicePlan(payload).then(function (plan) {
                dispatch(createPlanSuccess(plan));
                return plan;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createPlanFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }));

    return function (_x32) {
      return _ref32.apply(this, arguments);
    };
  }();
};
export var updatePlan = function updatePlan(planId, plan) {
  return /*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(dispatch) {
      var updatePlanRequest, updatePlanSuccess, updatePlanFail;
      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              updatePlanRequest = providerActionCreators.updatePlanRequest, updatePlanSuccess = providerActionCreators.updatePlanSuccess, updatePlanFail = providerActionCreators.updatePlanFail;
              dispatch(updatePlanRequest());
              return _context33.abrupt("return", httpProviderService.updatePlan(planId, plan).then(function (plan) {
                dispatch(updatePlanSuccess(plan));
                return plan;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updatePlanFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33);
    }));

    return function (_x33) {
      return _ref33.apply(this, arguments);
    };
  }();
};
export var activatePlan = function activatePlan(serviceId, planId) {
  return /*#__PURE__*/function () {
    var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(dispatch) {
      var activatePlanRequest, activatePlanSuccess, activatePlanFail;
      return _regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              activatePlanRequest = providerActionCreators.activatePlanRequest, activatePlanSuccess = providerActionCreators.activatePlanSuccess, activatePlanFail = providerActionCreators.activatePlanFail;
              dispatch(activatePlanRequest());
              return _context34.abrupt("return", httpProviderService.activatePlan(serviceId, planId).then(function (plan) {
                dispatch(activatePlanSuccess(plan));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(activatePlanFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34);
    }));

    return function (_x34) {
      return _ref34.apply(this, arguments);
    };
  }();
};
export var deactivatePlan = function deactivatePlan(serviceId, planId) {
  return /*#__PURE__*/function () {
    var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(dispatch) {
      var deactivatePlanRequest, deactivatePlanSuccess, deactivatePlanFail;
      return _regeneratorRuntime.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              deactivatePlanRequest = providerActionCreators.deactivatePlanRequest, deactivatePlanSuccess = providerActionCreators.deactivatePlanSuccess, deactivatePlanFail = providerActionCreators.deactivatePlanFail;
              dispatch(deactivatePlanRequest());
              return _context35.abrupt("return", httpProviderService.deactivatePlan(serviceId, planId).then(function (plan) {
                dispatch(deactivatePlanSuccess(plan));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(deactivatePlanFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35);
    }));

    return function (_x35) {
      return _ref35.apply(this, arguments);
    };
  }();
};
export var deletePlan = function deletePlan(serviceId, planId) {
  return /*#__PURE__*/function () {
    var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(dispatch) {
      var deletePlanRequest, deletePlanSuccess, deletePlanFail;
      return _regeneratorRuntime.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              deletePlanRequest = providerActionCreators.deletePlanRequest, deletePlanSuccess = providerActionCreators.deletePlanSuccess, deletePlanFail = providerActionCreators.deletePlanFail;
              dispatch(deletePlanRequest());
              return _context36.abrupt("return", httpProviderService.deletePlan(serviceId, planId).then(function () {
                dispatch(deletePlanSuccess(planId));
                return true;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(deletePlanFail(message));
                handleErrorResponse(error, dispatch);
                return false;
              }));

            case 3:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee36);
    }));

    return function (_x36) {
      return _ref36.apply(this, arguments);
    };
  }();
};
export var deletePlanFeature = function deletePlanFeature(serviceId, planId, featureId) {
  return /*#__PURE__*/function () {
    var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(dispatch) {
      var deletePlanFeatureRequest, deletePlanFeatureSuccess, deletePlanFeatureFail;
      return _regeneratorRuntime.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              deletePlanFeatureRequest = providerActionCreators.deletePlanFeatureRequest, deletePlanFeatureSuccess = providerActionCreators.deletePlanFeatureSuccess, deletePlanFeatureFail = providerActionCreators.deletePlanFeatureFail;
              dispatch(deletePlanFeatureRequest());
              return _context37.abrupt("return", httpProviderService.deletePlanFeature(serviceId, planId, featureId).then(function () {
                dispatch(deletePlanFeatureSuccess(featureId));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(deletePlanFeatureFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context37.stop();
          }
        }
      }, _callee37);
    }));

    return function (_x37) {
      return _ref37.apply(this, arguments);
    };
  }();
};
export var getServiceSubscriptions = function getServiceSubscriptions(serviceId) {
  return /*#__PURE__*/function () {
    var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(dispatch) {
      var getServiceSubscriptionsRequest, getServiceSubscriptionsSuccess, getServiceSubscriptionsFail;
      return _regeneratorRuntime.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              getServiceSubscriptionsRequest = providerActionCreators.getServiceSubscriptionsRequest, getServiceSubscriptionsSuccess = providerActionCreators.getServiceSubscriptionsSuccess, getServiceSubscriptionsFail = providerActionCreators.getServiceSubscriptionsFail;
              dispatch(getServiceSubscriptionsRequest());
              return _context38.abrupt("return", httpProviderService.getServiceSubscriptions(serviceId).then(function (subscriptions) {
                dispatch(getServiceSubscriptionsSuccess(subscriptions));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getServiceSubscriptionsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context38.stop();
          }
        }
      }, _callee38);
    }));

    return function (_x38) {
      return _ref38.apply(this, arguments);
    };
  }();
};
export var getServiceCustomersPromoTrue = function getServiceCustomersPromoTrue(serviceId) {
  return /*#__PURE__*/function () {
    var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(dispatch) {
      var getServiceCustomersPromoTrueRequest, getServiceCustomersPromoTrueSuccess, getServiceCustomersPromoTrueFail;
      return _regeneratorRuntime.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              getServiceCustomersPromoTrueRequest = providerActionCreators.getServiceCustomersPromoTrueRequest, getServiceCustomersPromoTrueSuccess = providerActionCreators.getServiceCustomersPromoTrueSuccess, getServiceCustomersPromoTrueFail = providerActionCreators.getServiceCustomersPromoTrueFail;
              dispatch(getServiceCustomersPromoTrueRequest());
              return _context39.abrupt("return", httpProviderService.getServiceCustomersPromoTrue(serviceId).then(function (subscriptions) {
                dispatch(getServiceCustomersPromoTrueSuccess(subscriptions));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getServiceCustomersPromoTrueFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context39.stop();
          }
        }
      }, _callee39);
    }));

    return function (_x39) {
      return _ref39.apply(this, arguments);
    };
  }();
};
export var getServiceTerms = function getServiceTerms(serviceId) {
  return /*#__PURE__*/function () {
    var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(dispatch) {
      var getServiceTermsRequest, getServiceTermsSuccess, getServiceTermsFail;
      return _regeneratorRuntime.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              getServiceTermsRequest = providerActionCreators.getServiceTermsRequest, getServiceTermsSuccess = providerActionCreators.getServiceTermsSuccess, getServiceTermsFail = providerActionCreators.getServiceTermsFail;
              dispatch(getServiceTermsRequest());
              return _context40.abrupt("return", httpProviderService.getServiceTerms(serviceId).then(function (serviceTerms) {
                dispatch(getServiceTermsSuccess(serviceTerms));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getServiceTermsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context40.stop();
          }
        }
      }, _callee40);
    }));

    return function (_x40) {
      return _ref40.apply(this, arguments);
    };
  }();
};
export var createServiceTerms = function createServiceTerms(payload) {
  return /*#__PURE__*/function () {
    var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(dispatch) {
      var createServiceTermsRequest, createServiceTermsSuccess, createServiceTermsFail;
      return _regeneratorRuntime.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              createServiceTermsRequest = providerActionCreators.createServiceTermsRequest, createServiceTermsSuccess = providerActionCreators.createServiceTermsSuccess, createServiceTermsFail = providerActionCreators.createServiceTermsFail;
              dispatch(createServiceTermsRequest());
              return _context41.abrupt("return", httpProviderService.createServiceTerms(payload).then(function (serviceTerms) {
                dispatch(createServiceTermsSuccess(serviceTerms));
                return serviceTerms;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createServiceTermsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context41.stop();
          }
        }
      }, _callee41);
    }));

    return function (_x41) {
      return _ref41.apply(this, arguments);
    };
  }();
};
export var updateServiceTerms = function updateServiceTerms(payload) {
  return /*#__PURE__*/function () {
    var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(dispatch) {
      var updateServiceTermsRequest, updateServiceTermsSuccess, updateServiceTermsFail;
      return _regeneratorRuntime.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              updateServiceTermsRequest = providerActionCreators.updateServiceTermsRequest, updateServiceTermsSuccess = providerActionCreators.updateServiceTermsSuccess, updateServiceTermsFail = providerActionCreators.updateServiceTermsFail;
              dispatch(updateServiceTermsRequest());
              return _context42.abrupt("return", httpProviderService.updateServiceTerms(payload).then(function (serviceTerms) {
                dispatch(updateServiceTermsSuccess(serviceTerms));
                return serviceTerms;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateServiceTermsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context42.stop();
          }
        }
      }, _callee42);
    }));

    return function (_x42) {
      return _ref42.apply(this, arguments);
    };
  }();
};
export var getServiceCustomers = function getServiceCustomers(serviceId) {
  return /*#__PURE__*/function () {
    var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(dispatch) {
      var getServiceCustomersRequest, getServiceCustomersSuccess, getServiceCustomersFail;
      return _regeneratorRuntime.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              getServiceCustomersRequest = providerActionCreators.getServiceCustomersRequest, getServiceCustomersSuccess = providerActionCreators.getServiceCustomersSuccess, getServiceCustomersFail = providerActionCreators.getServiceCustomersFail;
              dispatch(getServiceCustomersRequest());
              return _context43.abrupt("return", httpProviderService.getServiceCustomers(serviceId).then(function (serviceCustomers) {
                dispatch(getServiceCustomersSuccess(serviceCustomers));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getServiceCustomersFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context43.stop();
          }
        }
      }, _callee43);
    }));

    return function (_x43) {
      return _ref43.apply(this, arguments);
    };
  }();
};
export var createVerifiedServiceProspect = function createVerifiedServiceProspect(payload) {
  return /*#__PURE__*/function () {
    var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(dispatch) {
      var createVerifiedServiceProspectRequest, createVerifiedServiceProspectSuccess, createVerifiedServiceProspectFail;
      return _regeneratorRuntime.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              createVerifiedServiceProspectRequest = providerActionCreators.createVerifiedServiceProspectRequest, createVerifiedServiceProspectSuccess = providerActionCreators.createVerifiedServiceProspectSuccess, createVerifiedServiceProspectFail = providerActionCreators.createVerifiedServiceProspectFail;
              dispatch(createVerifiedServiceProspectRequest(payload));
              return _context44.abrupt("return", httpProviderService.createVerifiedServiceProspect(payload).then(function (serviceProspect) {
                dispatch(createVerifiedServiceProspectSuccess(serviceProspect));
                return serviceProspect;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createVerifiedServiceProspectFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context44.stop();
          }
        }
      }, _callee44);
    }));

    return function (_x44) {
      return _ref44.apply(this, arguments);
    };
  }();
};
export var uploadServiceProspects = function uploadServiceProspects(payload) {
  return /*#__PURE__*/function () {
    var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(dispatch) {
      var uploadServiceProspectsRequest, uploadServiceProspectsSuccess, uploadServiceProspectsFail;
      return _regeneratorRuntime.wrap(function _callee45$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              uploadServiceProspectsRequest = providerActionCreators.uploadServiceProspectsRequest, uploadServiceProspectsSuccess = providerActionCreators.uploadServiceProspectsSuccess, uploadServiceProspectsFail = providerActionCreators.uploadServiceProspectsFail;
              dispatch(uploadServiceProspectsRequest(payload));
              return _context45.abrupt("return", httpProviderService.uploadProspectList(payload).then(function (serviceProspects) {
                dispatch(uploadServiceProspectsSuccess(serviceProspects));
                return serviceProspects;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(uploadServiceProspectsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context45.stop();
          }
        }
      }, _callee45);
    }));

    return function (_x45) {
      return _ref45.apply(this, arguments);
    };
  }();
};
export var updateProviderService = function updateProviderService(payload, message) {
  return /*#__PURE__*/function () {
    var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(dispatch) {
      var updateProviderServiceSuccess, updateProviderServiceFail, providerServiceDidChange, providerDidChange, userProviderDidChange;
      return _regeneratorRuntime.wrap(function _callee46$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              updateProviderServiceSuccess = providerActionCreators.updateProviderServiceSuccess, updateProviderServiceFail = providerActionCreators.updateProviderServiceFail, providerServiceDidChange = providerActionCreators.providerServiceDidChange, providerDidChange = providerActionCreators.providerDidChange;
              userProviderDidChange = authActionCreators.userProviderDidChange;
              return _context46.abrupt("return", httpProviderService.updateProviderService(payload).then(function (updatedProviderService) {
                dispatch(providerServiceDidChange(updatedProviderService));
                dispatch(providerDidChange(updatedProviderService === null || updatedProviderService === void 0 ? void 0 : updatedProviderService.provider));
                dispatch(userProviderDidChange(updatedProviderService === null || updatedProviderService === void 0 ? void 0 : updatedProviderService.provider));
                dispatch(updateProviderServiceSuccess(updatedProviderService, message));
                return updatedProviderService;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateProviderServiceFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context46.stop();
          }
        }
      }, _callee46);
    }));

    return function (_x46) {
      return _ref46.apply(this, arguments);
    };
  }();
};
export var createProvider = function createProvider(payload) {
  return /*#__PURE__*/function () {
    var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(dispatch) {
      var createProviderRequest, createProviderSuccess, createProviderFail, userProviderDidChange;
      return _regeneratorRuntime.wrap(function _callee47$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              createProviderRequest = providerActionCreators.createProviderRequest, createProviderSuccess = providerActionCreators.createProviderSuccess, createProviderFail = providerActionCreators.createProviderFail;
              userProviderDidChange = authActionCreators.userProviderDidChange;
              dispatch(createProviderRequest(payload));
              return _context47.abrupt("return", httpProviderService.createProvider(payload).then(function (provider) {
                dispatch(userProviderDidChange(provider));
                dispatch(createProviderSuccess(provider));
                return provider;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createProviderFail(message));
                handleErrorResponse(error, dispatch);
                throw error;
              }));

            case 4:
            case "end":
              return _context47.stop();
          }
        }
      }, _callee47);
    }));

    return function (_x47) {
      return _ref47.apply(this, arguments);
    };
  }();
};
export var updateProvider = function updateProvider(payload) {
  return /*#__PURE__*/function () {
    var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(dispatch) {
      var updateProviderRequest, updateProviderSuccess, updateProviderFail, userProviderDidChange;
      return _regeneratorRuntime.wrap(function _callee48$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              updateProviderRequest = providerActionCreators.updateProviderRequest, updateProviderSuccess = providerActionCreators.updateProviderSuccess, updateProviderFail = providerActionCreators.updateProviderFail;
              userProviderDidChange = authActionCreators.userProviderDidChange;
              dispatch(updateProviderRequest(payload));
              return _context48.abrupt("return", httpProviderService.updateProvider(payload).then(function (provider) {
                dispatch(userProviderDidChange(provider));
                dispatch(updateProviderSuccess(provider));
                return provider;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateProviderFail(message));
                handleErrorResponse(error, dispatch);
                throw error;
              }));

            case 4:
            case "end":
              return _context48.stop();
          }
        }
      }, _callee48);
    }));

    return function (_x48) {
      return _ref48.apply(this, arguments);
    };
  }();
};
export var createProviderService = function createProviderService(payload) {
  return /*#__PURE__*/function () {
    var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(dispatch) {
      var createProviderServiceRequest, createProviderServiceSuccess, createProviderServiceFail, userProviderServiceDidChange;
      return _regeneratorRuntime.wrap(function _callee49$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              createProviderServiceRequest = providerActionCreators.createProviderServiceRequest, createProviderServiceSuccess = providerActionCreators.createProviderServiceSuccess, createProviderServiceFail = providerActionCreators.createProviderServiceFail;
              userProviderServiceDidChange = authActionCreators.userProviderServiceDidChange;
              dispatch(createProviderServiceRequest(payload));
              return _context49.abrupt("return", httpProviderService.createProviderService(payload).then(function (service) {
                dispatch(userProviderServiceDidChange(service));
                dispatch(createProviderServiceSuccess(service));
                return service;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createProviderServiceFail(message));
                handleErrorResponse(error, dispatch);
                throw error;
              }));

            case 4:
            case "end":
              return _context49.stop();
          }
        }
      }, _callee49);
    }));

    return function (_x49) {
      return _ref49.apply(this, arguments);
    };
  }();
};
export var setProviderSelectedServiceId = function setProviderSelectedServiceId(payload) {
  return function (dispatch) {
    var setProviderSelectedServiceIdAction = providerActionCreators.setProviderSelectedServiceId;
    dispatch(setProviderSelectedServiceIdAction(payload));
  };
};
export var getActiveReferralProgram = function getActiveReferralProgram(serviceId) {
  return /*#__PURE__*/function () {
    var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(dispatch) {
      var getActiveReferralProgramRequest, getActiveReferralProgramSuccess, getActiveReferralProgramFail;
      return _regeneratorRuntime.wrap(function _callee50$(_context50) {
        while (1) {
          switch (_context50.prev = _context50.next) {
            case 0:
              getActiveReferralProgramRequest = providerActionCreators.getActiveReferralProgramRequest, getActiveReferralProgramSuccess = providerActionCreators.getActiveReferralProgramSuccess, getActiveReferralProgramFail = providerActionCreators.getActiveReferralProgramFail;
              dispatch(getActiveReferralProgramRequest());
              return _context50.abrupt("return", httpProviderService.getActiveReferralProgram(serviceId).then(function (referralProgram) {
                dispatch(getActiveReferralProgramSuccess(referralProgram));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getActiveReferralProgramFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context50.stop();
          }
        }
      }, _callee50);
    }));

    return function (_x50) {
      return _ref50.apply(this, arguments);
    };
  }();
};
export var getServicePostMailingList = function getServicePostMailingList(serviceId, postId) {
  return /*#__PURE__*/function () {
    var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(dispatch) {
      var getServicePostMailingListRequest, getServicePostMailingListSuccess, getServicePostMailingListFail;
      return _regeneratorRuntime.wrap(function _callee51$(_context51) {
        while (1) {
          switch (_context51.prev = _context51.next) {
            case 0:
              getServicePostMailingListRequest = providerActionCreators.getServicePostMailingListRequest, getServicePostMailingListSuccess = providerActionCreators.getServicePostMailingListSuccess, getServicePostMailingListFail = providerActionCreators.getServicePostMailingListFail;
              dispatch(getServicePostMailingListRequest());
              return _context51.abrupt("return", httpProviderService.getServicePostMailingList(serviceId, postId).then(function (mailingList) {
                dispatch(getServicePostMailingListSuccess(mailingList));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getServicePostMailingListFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context51.stop();
          }
        }
      }, _callee51);
    }));

    return function (_x51) {
      return _ref51.apply(this, arguments);
    };
  }();
};
export var ICreatePlanProspect = function ICreatePlanProspect() {
  _classCallCheck(this, ICreatePlanProspect);

  _defineProperty(this, "planId", void 0);

  _defineProperty(this, "serviceId", void 0);
};
export var getPlanProspectsForPlan = function getPlanProspectsForPlan(dto) {
  return /*#__PURE__*/function () {
    var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(dispatch) {
      var getPlanProspectsRequest, getPlanProspectsSuccess, getPlanProspectsFail;
      return _regeneratorRuntime.wrap(function _callee52$(_context52) {
        while (1) {
          switch (_context52.prev = _context52.next) {
            case 0:
              getPlanProspectsRequest = providerActionCreators.getPlanProspectsRequest, getPlanProspectsSuccess = providerActionCreators.getPlanProspectsSuccess, getPlanProspectsFail = providerActionCreators.getPlanProspectsFail;
              dispatch(getPlanProspectsRequest());
              return _context52.abrupt("return", httpProviderService.getPlanProspectsForPlan(dto).then(function (result) {
                dispatch(getPlanProspectsSuccess(result));
                return result;
              }, function (error) {
                dispatch(getPlanProspectsFail(error));
              }));

            case 3:
            case "end":
              return _context52.stop();
          }
        }
      }, _callee52);
    }));

    return function (_x52) {
      return _ref52.apply(this, arguments);
    };
  }();
};
export var getPlanProspectsForService = function getPlanProspectsForService(serviceId) {
  return /*#__PURE__*/function () {
    var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(dispatch) {
      var getPlanProspectsRequest, getPlanProspectsSuccess, getPlanProspectsFail;
      return _regeneratorRuntime.wrap(function _callee53$(_context53) {
        while (1) {
          switch (_context53.prev = _context53.next) {
            case 0:
              getPlanProspectsRequest = providerActionCreators.getPlanProspectsRequest, getPlanProspectsSuccess = providerActionCreators.getPlanProspectsSuccess, getPlanProspectsFail = providerActionCreators.getPlanProspectsFail;
              dispatch(getPlanProspectsRequest());
              return _context53.abrupt("return", httpProviderService.getPlanProspectsForService(serviceId).then(function (result) {
                dispatch(getPlanProspectsSuccess(result));
                return result;
              }, function (error) {
                dispatch(getPlanProspectsFail(error));
              }));

            case 3:
            case "end":
              return _context53.stop();
          }
        }
      }, _callee53);
    }));

    return function (_x53) {
      return _ref53.apply(this, arguments);
    };
  }();
};
export var createPlanProspect = function createPlanProspect(dto) {
  return /*#__PURE__*/function () {
    var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(dispatch) {
      var createPlanProspectRequest, createPlanProspectSuccess, createServiceProspectSuccess, createPlanProspectFail;
      return _regeneratorRuntime.wrap(function _callee54$(_context54) {
        while (1) {
          switch (_context54.prev = _context54.next) {
            case 0:
              createPlanProspectRequest = providerActionCreators.createPlanProspectRequest, createPlanProspectSuccess = providerActionCreators.createPlanProspectSuccess, createServiceProspectSuccess = providerActionCreators.createServiceProspectSuccess, createPlanProspectFail = providerActionCreators.createPlanProspectFail;
              dispatch(createPlanProspectRequest());
              return _context54.abrupt("return", httpProviderService.createPlanProspect(dto).then(function (result) {
                dispatch(createPlanProspectSuccess(result.planProspect));
                dispatch(createServiceProspectSuccess(result.serviceProspect));
                return result;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createPlanProspectFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context54.stop();
          }
        }
      }, _callee54);
    }));

    return function (_x54) {
      return _ref54.apply(this, arguments);
    };
  }();
};